const TABLES = [
  'COUNTRY',
  'DEGREES',
  'UNIVERSITY',
  'GRAD_YEAR',
  'GRAD_MONTH',
  'YEAR_ATTEND',
  'AREAS_OF_PRACTICE',
  'WORK_ENVIRONMENT',
  'INSURANCE',
  'JOIN_REASON',
  'JOB_DESCRIPTION'
]

const lookupData = (
  state: any = {},
  action: any
) => {
  const actionTable = TABLES.find(table => action.type.indexOf(table) !== -1)
  const table = actionTable ? actionTable : ''
  switch (action.type) {
    case 'LOOKUP_DATA_REQUESTED':
      return {
        ...state,
        status: 'requested',
        error: null
      }
    case 'LOOKUP_DATA_FAILED':
      return {
        ...state,
        status: 'error',
        error: action.payload
      }
    case 'LOOKUP_DATA_SUCCESS':
      return {
        ...state,
        status: 'success'
      }
    case `GET_${table}_REQUESTED`:
      return {
        ...state,
        [table]: {
          status: 'loading'
        }
      }
    case `GET_${table}_FAILED`:
      return {
        ...state,
        [table]: {
          status: 'error',
          error: action.payload
        }
      }
    case `GET_${table}_SUCCESS`:
      return {
        ...state,
        [table]: {
          status: 'success',
          data:
            table === 'UNIVERSITY'
              ? action.payload
                  .map(item => {
                    return {
                      ...item,
                      original: item.Name,
                      disabled: item.Name.indexOf('(x)') !== -1,
                      Name: item.Name.replace('(x)', '').trim()
                    }
                  })
                  .sort((item1, item2) => {
                    if (item1.Name < item2.Name) {
                      return -1
                    }
                    if (item1.Name > item2.Name) {
                      return 1
                    }
                    return 0
                  })
              : action.payload
        }
      }
    default:
      return state
  }
}

export default lookupData
